export default __webpack_public_path__ + "static/media/india gate.62e8afe5.svg";